import React, { useEffect, useRef, useState } from 'react';
import { AppWindow, ArrowRight, ChevronUp, Globe, Laptop, Mail, Megaphone, Phone, Send, ChevronDown, Eye, ArrowUpRight, MessageCircle, PenTool, BarChart2, Heart } from 'lucide-react';
import TestimonialsSection from '../components/testimonials/TestimonialsSection';
import { Link } from 'react-router-dom';

export default function Home() {

    const emojis = [
        {
            url: '/mascots/girl-1.webp',
            heading: 'Crafting Creativity That Sells',
            paragraph: 'We don’t just design, we design with purpose. Every pixel, every post, focused on growing your business.'
        }, {
            url: '/mascots/boy-1.webp',
            heading: 'Your Brand. Our Bold Edge.',
            paragraph: 'Every brand needs a voice. We help you find yours, and make sure it gets heard loud and clear.'
        },
        {
            url: '/mascots/boy-2.webp',
            heading: 'Shoot. Edit. Upload. Repeat.',
            paragraph: 'On-site shoots, product photography, reels, or ads, our creative team gets it done fast & fabulous.'
        },
        {
            url: '/mascots/girl-2.webp',
            heading: 'Transparent Pricing',
            paragraph: 'No vague packages or hidden charges. Bold Edge offers clear pricing, custom packages, and true ROI.'
        },
        {
            url: '/mascots/girl-3.webp',
            heading: 'Women Safety',
            paragraph: 'We can send a female creator from our talented team for your shoot, ensuring comfort, safety, and creativity.'
        },
        {
            url: '/mascots/boy-3.webp',
            heading: 'Unbelievable Pricing',
            paragraph: 'Premium creativity at rates you won’t believe.'
        }
    ]

    const home_images = [
        '/works/aurum-1.webp',
        '/works/aurum-2.webp',
        '/works/aurum-3.webp',
        '/works/aurum-4.webp',
        '/works/aurum-5.webp',
        '/works/aurum-6.webp',

        '/works/brulerie-1.webp',
        '/works/brulerie-2.webp',
        '/works/brulerie-3.webp',
        '/works/brulerie-4.webp',
        '/works/brulerie-5.webp',

        '/works/mehfil-1.webp',
        '/works/mehfil-2.webp',
        '/works/mehfil-3.webp',
        '/works/mehfil-4.webp',
        '/works/mehfil-5.webp',
        '/works/mehfil-6.webp',
    ];


    return (
        <>
            <section className='px-0 h-[calc(100svh-9rem)] relative flex items-center'>
                <div className='text-center w-full'>
                    <h1 className='px-3 text-3xl md:text-[5rem] leading-[1.1] font-extrabold'>Marketing that Speaks<br />
                        Designs that Convert<span className='text-brand-orange'>.</span> </h1>
                    <div className='mt-6 md:mt-8 flex flex-wrap gap-y-3 gap-x-10 justify-center [&_*]:font-poppins [&_*]:font-normal'>
                        <div className='max-md:text-sm flex gap-x-1'>
                            <span>✅</span>
                            <p>Creative Without Limits</p>
                        </div>
                        <div className='max-md:text-sm flex gap-x-1'>
                            <span>⚡</span>
                            <p>Fast turnaround (24-48 hrs)</p>
                        </div>
                        <div className='max-md:text-sm flex gap-x-1'>
                            <span>🎯</span>
                            <p>Strategy-Driven Designs</p>
                        </div>
                    </div>
                    <div className='relative mt-16 overflow-hidden'>
                        <div className='animate-home-images flex gap-3'>
                            {
                                home_images.map((image, index) => (
                                    <img key={`first-${index}`} src={image} className='w-36 rounded-lg block object-cover' />
                                ))
                            }
                            {
                                home_images.map((image, index) => (
                                    <img key={`second-${index}`} src={image} className='w-36 rounded-lg block object-cover' />
                                ))
                            }
                        </div>
                        {/* Left vignette */}
                        <div className='absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-black via-black/40 to-transparent pointer-events-none z-10'></div>
                        {/* Right vignette */}
                        <div className='absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-black via-black/40 to-transparent pointer-events-none z-10'></div>
                    </div>
                    <div className='mt-12'>
                        <p className='text-lg font-poppins font-semibold'>Work That <span className='font-poppins text-brand-orange italic'>Speaks for Itself.</span></p>
                    </div>
                </div>
            </section>
            {/* <DartSection /> */}
            {/* <SpriteScrollAnimation /> */}
            <section className="">
                <h1 className='text-3xl md:text-center md:text-6xl font-extrabold'>Not Just Digital Marketing,<br />
                    But...<span className='text-brand-orange'>Your Bold Edge!</span> </h1>

                <div className="mt-12">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-y-6 md:gap-10">
                        {emojis.map((emoji, index) => (
                            <div className='flex gap-x-0 md:gap-x-6 border border-brand-orange rounded-xl  bg-[#28150a]'>
                                <img src={emoji.url} className='md:ml-12 pt-4 w-32  mt-auto block' />
                                <div className='max-md:pl-2 p-6 h-fit mt-auto'>
                                    <h3 className='text-lg md:text-2xl font-bold'>{emoji.heading}</h3>
                                    <p className='mt-1.5 text-sm text-gray-200'>{emoji.paragraph}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            {/* <section>
                <div className="grid md:grid-cols-3 gap-x-8 gap-y-4">
                    <div className='h-fit my-auto'>
                        <h2 className='font-normal text-2xl md:text-3xl leading-relaxed '>
                            Empowering businesses with innovative <span className='text-brand-orange'> digital solutions </span>and delivering exceptional experiences that drive measurable success.
                        </h2>
                    </div>
                    <div className=''>
                        <img className='block w-full' src="/home/empowering-1.jpg" alt="" />
                    </div>
                    <div className='h-fit my-auto'>
                        <p>We craft smart digital solutions tailored to

                            your goals. Focused on results, we deliver experiences that elevate your brand.</p>
                        <button className='orange mt-4'>
                            Learn More
                        </button>
                    </div>
                </div>
            </section> */}
            {/* <section className="relative bg-[#252525]">
                <div className="grid md:grid-cols-2 gap-y-8 gap-x-8">
                    <div className="md:relative">
                        <div className="top-24 sticky">
                            <p className="text-gray-300 text-xl font-poppins">How We Work</p>
                            <p className="text-3xl md:text-5xl text-white font-semibold">
                                Smart. Seamless. Strategic.
                            </p>
                            <p className="mt-5 font-normal text-lg text-white">
                                From concept to conversion, we make digital simple. No fluff, just real results for brands that dare to stand out.
                            </p>
                            <button className="block mt-5 md:mt-12 orange !text-black">
                                Let’s Build Something Bold
                            </button>
                        </div>
                    </div>
                    <div className="relative space-y-7">
                        <div className="bg-[#202020] border border-[#303030] rounded-xl p-6">
                            <Laptop color="white" className="w-20 h-20" strokeWidth={1} />
                            <h3 className="text-brand-orange mt-4 font-poppins text-2xl font-semibold">
                                Digital-First Strategy
                            </h3>
                            <p className="mt-2 text-white font-poppins text-base">
                                We dive deep into your brand and goals to craft strategies that connect, convert, and scale.
                            </p>
                        </div>
                        <div className="bg-[#202020] border border-[#303030] rounded-xl p-6">
                            <PenTool color="white" className="w-20 h-20" strokeWidth={1} />
                            <h3 className="text-brand-orange mt-4 font-poppins text-2xl font-semibold">
                                Design That Performs
                            </h3>
                            <p className="mt-2 text-white font-poppins text-base">
                                We design experiences that look incredible and work even better — built to impress and convert.
                            </p>
                        </div>
                        <div className="bg-[#202020] border border-[#303030] rounded-xl p-6">
                            <BarChart2 color="white" className="w-20 h-20" strokeWidth={1} />
                            <h3 className="text-brand-orange mt-4 font-poppins text-2xl font-semibold">
                                Results That Matter
                            </h3>
                            <p className="mt-2 text-white font-poppins text-base">
                                We measure what matters — delivering impact, insights, and ROI that drive growth and prove value.
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}



            <TestimonialsSection />

            {/*  <section className="lg:hidden block min-h-screen  relative overflow-hidden ">



                <div className="text-center mb-12">
                    <div className="text-center w-fit mx-auto mb-4">
                        <div className="flex items-center gap-2 text-gray-500 text-sm">
                            <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                            <span>Several people are still typing...</span>
                        </div>
                    </div>
                    <h1 className="text-3xl md:text-7xl font-bold text-gray-900 mb-4">
                        We're the best.
                        <br />
                        Trust us on that.
                    </h1>

                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Take a look on Crustpilot & Mutch yourself and get to know how we're acing through our
                        branding tests from various big companies.
                    </p>
                </div>
                <div className=" bg-white rounded-2xl p-4 shadow-lg max-w-sm transform -rotate-6 hover:rotate-0 transition-transform duration-300">
                    <p className="text-gray-800 text-sm mb-3">
                        "Lulea is one of the best studios on the go at this very current moment like i bet you cant find better than this lol.."
                    </p>
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-gray-700 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs font-bold">A</span>
                        </div>
                        <span className="text-gray-600 text-xs">Amanda from Opal Studios</span>
                    </div>
                </div>
                <div className=" bg-white rounded-2xl  p-4 shadow-lg  transform rotate-0 hover:rotate-0 transition-transform duration-300">
                    <p className="text-gray-800 text-sm mb-3">
                        "One of the craziest studios i've worked with like honestly they were beyond crazy"
                    </p>
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-blue-400 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs font-bold">C</span>
                        </div>
                        <span className="text-gray-600 text-xs">Crystle from Mavik</span>
                    </div>
                </div>

                <div className=" bg-white rounded-2xl p-4 shadow-lg max-w-sm transform rotate-6 hover:rotate-0 transition-transform duration-300">
                    <p className="text-gray-800 text-sm mb-3">
                        "Can't get better than this, like really."
                    </p>
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-yellow-600 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs font-bold">O</span>
                        </div>
                        <span className="text-gray-600 text-xs">Optimus from Transformers</span>
                    </div>
                </div>

                <div className=" bg-white rounded-2xl p-4 shadow-lg max-w-sm transform rotate-[10deg] hover:rotate-0 transition-transform duration-300">
                    <p className="text-gray-800 text-sm mb-3">
                        "Totally Love these guys"
                    </p>
                    <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-green-600 rounded-full flex items-center justify-center">
                            <span className="text-white text-xs font-bold">W</span>
                        </div>
                        <span className="text-gray-600 text-xs">Wang from Solleko</span>
                    </div>
                </div>


            </section> */}

            {/* OLD CONTACT CTA  */}
            {/* <section>
                <h2 className='uppercase md:w-[80%] mx-auto text-2xl md:text-5xl font-bold text-center'>
                    Let's revolutionize how <span className='lowercase font-light font-poppins italic' > startups launch</span> websites by replacing bloated teams with one expert that has complete <span className='lowercase font-light font-poppins italic' > oversight</span>.
                </h2>
                <p className='mt-2 md:mt-7 md:text-lg font-normal  text-center max-w-[80%] lg:max-w-[60%] mx-auto'>We already know it’s a creative match. Let’s schedule our first design date, we’re excited to hear your idea and start sketching magic.</p>
                <div className='flex flex-col mx-auto w-fit md:flex-row justify-center gap-4 mt-8'>
                    <button className="max-md:w-fit max-md:mx-auto md:text-lg orange gap-x-3"><Phone size={20} className='block h-fit my-auto' /> Contact Us</button>
                    <button className="max-md:w-fit max-md:mx-auto md:text-lg transparent gap-x-3"><Mail size={20} className='block h-fit my-auto' /> Send an Email</button>

                </div>
            </section> */}


            <section className="  flex relative object-center !opacity-100 items-center justify-center overflow-hidden">
                {/* <video playsInline loop autoPlay muted className='brightness-[30%] block absolute top-0 z-[0] left-0 right-0 bottom-0 w-full h-full object-cover' src="/home/brand.mp4"></video> */}
                <div className="text-center max-w-4xl mx-auto [&_*]:z-10 relative">
                    {/* Available Now Badge */}
                    <div className="inline-flex items-center gap-2 bg-[#202020] text-white px-4 py-2 rounded-full text-sm font-medium mb-12">
                        <div className="w-2 h-2 bg-green-400 rounded-full"></div>
                        AVAILABLE NOW
                    </div>

                    {/* Main Heading */}
                    <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 leading-tight">
                        Interested in<br />
                        working <span className="text-brand-orange">together?</span>
                    </h1>

                    {/* Subtext */}
                    <p className="text-gray-200 text-lg md:text-lg mb-16 max-w-2xl mx-auto leading-relaxed">
                        Let's talk and explore the endless possibilities for your<br />
                        business success. Book a call today.
                    </p>
                    <div className='flex flex-wrap gap-y-4 gap-x-4 items-center mx-auto justify-center w-fit  ' >
                        <Link to={'/contact'}>
                            <button className="orange flex items-center gap-2 w-fit  mx-auto !text-white  shadow-lg">Get a Free Quote <ArrowRight size={18} /> </button>
                        </Link>
                        <a href="https://api.whatsapp.com/send/?phone=1234567890&text=Hi%21+I%27m+interested+in+learning+more+about+Bold+Edge+Media%27s+services.&type=phone_number&app_absent=0">
                            <button className="  border-green-500   bg-green-500 hover:bg-green-600 text-white flex items-center gap-2  shadow-lg transition-all duration-300">
                                {/* <img className='w-6 h-6' src="/icons/whatsapp.png" alt="" /> */}
                                Chat on WhatsApp
                                <ArrowRight size={18} />
                            </button>
                        </a>
                    </div>
                    {/* Rotating Text with Eye Icon */}
                    {/* <div className="relative inline-block">
                        <div className="relative w-32 h-32 mx-auto">
                            <div className="absolute inset-0 animate-spin" style={{ animationDuration: '20s' }}>
                                <svg viewBox="0 0 128 128" className="w-full h-full">
                                    <defs>
                                        <path
                                            id="circle"
                                            d="M 64, 64 m -50, 0 a 50,50 0 1,1 100,0 a 50,50 0 1,1 -100,0"
                                        />
                                    </defs>
                                    <text className="text-xs fill-gray-400 font-medium tracking-widest">
                                        <textPath href="#circle" startOffset="0%">
                                            FREE QUOTE • LET'S TALK • GET A
                                        </textPath>
                                    </text>
                                </svg>
                            </div>

                            <div className="absolute inset-0 flex items-center justify-center">
                                <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center border border-gray-700">
                                    <Eye className="w-6 h-6 text-gray-300" />
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>
            <HomepageFAQ />

            {/* <WhatsAppFAQChat /> */}
        </>
    );
}


function HomepageFAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const faqData = [
        {
            question: "What services does Bold Edge Media offer?",
            answer: "We specialize in branding, social media marketing, website design, content creation, and performance marketing, crafted to help your business cut through the noise and achieve real growth."
        },
        {
            question: "How do we get started with your team?",
            answer: "Getting started is simple! Reach out to us through our contact form or give us a call. We'll schedule a consultation to understand your business goals and create a customized strategy that fits your needs and budget."
        },
        {
            question: "Do you work with startups or only established brands?",
            answer: "We work with businesses of all sizes! From innovative startups looking to make their mark to established brands wanting to refresh their presence, we tailor our approach to meet you where you are in your journey."
        },
        {
            question: "How long does it take to see results from digital marketing?",
            answer: "Results vary depending on the strategy and goals. Some tactics like paid advertising can show immediate results, while SEO and brand building typically take 3-6 months to gain momentum. We'll set clear expectations during our initial consultation."
        },
        {
            question: "What makes Bold Edge Media different from other agencies?",
            answer: "Our focus on cutting-edge strategies, personalized attention, and data-driven results sets us apart. We don't believe in one-size-fits-all solutions - every campaign is crafted specifically for your brand's unique voice and goals."
        },
        {
            question: "Do you offer custom packages or fixed pricing?",
            answer: "We offer both! We have standard packages for common needs, but we specialize in creating custom packages tailored to your specific goals and budget. Every business is unique, and your marketing strategy should be too."
        }
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="">
            <div className="max-w-4xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">

                    <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4">
                        Got Questions?
                    </h1>

                    <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
                        Everything you need to know about becoming a <span className="text-brand-orange font-semibold">Bold Edge</span> partner
                    </p>
                </div>

                {/* FAQ Items */}
                <div className="space-y-4">
                    {faqData.map((item, index) => (
                        <div
                            key={index}
                            className="bg-white/5 backdrop-blur-sm  border-white/10 hover:border-primary/30  rounded-xl overflow-hidden transition-all duration-300 hover:border-brand-orange/50"
                        >
                            <p
                                onClick={() => toggleFAQ(index)}
                                className="hover:cursor-pointer w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none group"
                            >
                                <h3 className="text-lg md:text-xl font-normal text-white group-hover:text-brand-orange transition-colors duration-300 pr-4">
                                    {item.question}
                                </h3>
                                <div className="flex-shrink-0">
                                    {openIndex === index ? (
                                        <ChevronUp className="w-5 h-5 text-brand-orange transition-transform duration-300" />
                                    ) : (
                                        <ChevronDown className="w-5 h-5 text-gray-400 group-hover:text-brand-orange transition-colors duration-300" />
                                    )}
                                </div>
                            </p>

                            <div
                                className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <div className="px-6 pb-5">
                                    {/* <div className="h-px bg-[#303030] mb-4"></div> */}
                                    <p className="text-gray-300 leading-relaxed text-base">
                                        {item.answer}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
}

